import React from 'react';
import { useOrganization } from '../context/OrganizationContext';
import Sidebar from './Sidebar';
import OrganizationSidebar from './navigation/OrganizationSidebar';

/**
 * SidebarRouter Component
 *
 * Conditionally renders the appropriate sidebar based on current view mode:
 * - Individual mode → Sidebar.js (minimal 7-item menu, no fleet)
 * - Organization mode → OrganizationSidebar.js (full menu with fleet management)
 *
 * Uses OrganizationContext to determine current mode:
 * - isInOrganizationMode = true → Organization sidebar
 * - isInOrganizationMode = false → Individual sidebar
 *
 * Multi-tenant support: Users with both individual subscription and organization
 * membership can switch between modes using the OrganizationSelector in the navbar
 */
const SidebarRouter = ({ collapsed, onCollapsedChange, onNavigate, isInDrawer = false }) => {
  const { isInOrganizationMode, loading } = useOrganization();

  // Show loading state while determining user type
  if (loading) {
    return (
      <div style={{
        width: collapsed ? '64px' : '256px',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1e3a8a',
        borderRight: '1px solid #1e40af',
        transition: 'width 0.3s ease'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #1e40af',
            borderTop: '4px solid #ffffff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }} />
          {!collapsed && (
            <p style={{ marginTop: '12px', color: '#93c5fd', fontSize: '14px' }}>
              Loading...
            </p>
          )}
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Render organization sidebar when in organization mode
  if (isInOrganizationMode) {
    return <OrganizationSidebar collapsed={collapsed} onCollapsedChange={onCollapsedChange} onNavigate={onNavigate} isInDrawer={isInDrawer} />;
  }

  // Render individual sidebar when in individual mode

  // Individual Sidebar - pass collapsed state
  return <Sidebar collapsed={collapsed} onCollapsedChange={onCollapsedChange} onNavigate={onNavigate} isInDrawer={isInDrawer} />;
};

export default SidebarRouter;
